import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Компонент для сохранения параметров запуска (initData) в URL при навигации.
 * Запоминает параметры, с которыми было открыто приложение, и добавляет их
 * ко всем последующим переходам.
 */
const UrlPersistence = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Используем ref, чтобы запомнить начальные параметры один раз при загрузке
    const initialParamsRef = useRef(null);

    useEffect(() => {
        // При первой загрузке сохраняем параметры текущего URL
        if (initialParamsRef.current === null) {
            initialParamsRef.current = new URLSearchParams(window.location.search);
        }

        const initialParams = initialParamsRef.current;

        // Если начальных параметров нет, ничего не делаем
        if (Array.from(initialParams).length === 0) {
            return;
        }

        const currentParams = new URLSearchParams(location.search);
        let paramsChanged = false;

        // Проверяем, все ли начальные параметры присутствуют в текущем URL
        initialParams.forEach((value, key) => {
            if (!currentParams.has(key)) {
                currentParams.set(key, value);
                paramsChanged = true;
            }
        });

        // Если каких-то параметров не хватало, обновляем URL
        if (paramsChanged) {
            navigate(
                {
                    pathname: location.pathname,
                    search: currentParams.toString(),
                    hash: location.hash
                },
                { replace: true } // Используем replace, чтобы не засорять историю
            );
        }
    }, [location, navigate]);

    return null;
};

export default UrlPersistence;
